import { fetchProductCombos } from './productCombosRepo';
import {
  readComboParentProductIdsCache,
  writeComboParentProductIdsCache,
} from './comboParentProductIdsCache';

export { invalidateComboParentProductIdsCache } from './comboParentProductIdsCache';

/** IDs de productos padre con BOM (phantom kit). Cache corto por org. */
export async function getComboParentProductIds(
  orgId: string,
  productIds: string[],
): Promise<Set<string>> {
  if (!orgId || productIds.length === 0) return new Set();
  const cached = readComboParentProductIdsCache(orgId);
  if (cached) return cached;
  const combos = await fetchProductCombos(productIds);
  const ids = new Set(combos.keys());
  writeComboParentProductIdsCache(orgId, ids);
  return ids;
}
